import { testimonialConstants } from '../actions/types';

const initialState = {
  loading: false,
  testimonialsList: [],
  error: '',
};

const testimonialReducer = (state = initialState, action) => {
  switch (action.type) {
    case testimonialConstants.GET_TESTIMONIALS_REQUEST:
      return {
        ...state,
        loading: true,
        testimonialsList: [],
        error: '',
      };
    case testimonialConstants.GET_TESTIMONIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        testimonialsList: action.testimonials,
        error: '',
      };
    case testimonialConstants.GET_TESTIMONIALS_FAILURE:
      return {
        ...state,
        loading: false,
        testimonialsList: [],
        error: action.error,
      };
    default:
      return { ...state };
  }
};

export default testimonialReducer;
